module.exports = __webpack_public_path__ + "static/media/Scragg Nip Roller Bearing.a4cbf7ad.jpg";